/**
 * Login page — name + PIN form, posts to /api/auth/login.
 * On success, navigates by role (admin → /teacher, student → /student).
 */
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../stores/auth';

export function Login() {
  const navigate = useNavigate();
  const login = useAuth((s) => s.login);
  const error = useAuth((s) => s.error);
  const loading = useAuth((s) => s.loading);

  const [name, setName] = useState('');
  const [pin, setPin] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      const user = await login(name.trim(), pin);
      navigate(user.role === 'admin' ? '/teacher' : '/student', { replace: true });
    } catch {
      // error is already in store
    }
  }

  return (
    <main className="page-center">
      <form onSubmit={handleSubmit} className="login-card" data-testid="login-form" aria-label="로그인">
        <span className="login-brand">Lemma</span>
        <p className="login-subtitle">Mathematics Tutoring Platform</p>

        <div className="form-stack">
          <label className="label" htmlFor="login-name">
            Name
            <input
              id="login-name"
              data-testid="login-name"
              className="input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
              placeholder="이름을 입력하세요"
              aria-describedby={error ? 'login-error-msg' : undefined}
            />
          </label>

          <label className="label" htmlFor="login-pin">
            PIN
            <input
              id="login-pin"
              data-testid="login-pin"
              className="input"
              type="password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              required
              placeholder="PIN을 입력하세요"
              aria-describedby={error ? 'login-error-msg' : undefined}
            />
          </label>

          {error && (
            <p id="login-error-msg" data-testid="login-error" className="error-text" role="alert">
              {error}
            </p>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="btn btn-gold btn-lg w-full mt-3"
            aria-busy={loading}
          >
            {loading ? '로그인 중…' : '로그인'}
          </button>
        </div>
      </form>
    </main>
  );
}
